/** @module Enums */ /** typedoc */

// The user interaction sources should represent a position in the screen and not refer to a section or page in the app.
//
// ex:
//      ReleaseTitle    =>  BAD
//      RowTitle        =>  GOOD
export enum UserInteractionSourceEnum {
    TableButton = 'TableButton',
    RowButton = 'RowButton',
    RightClick = 'RightClick',
    ItemMenu = 'ItemMenu',
    SidebarButton = 'SidebarButton',
    BannerButton = 'BannerButton',
    Widget = 'Widget',
    EmptyStateButton = 'EmptyStateButton',
    Notification = 'Notification',
    RowCover = 'RowCover',
    RowTitle = 'RowTitle'
}
